import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { CommonServiceService } from './pages/services/common-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  modelePermission: any[] = [
    {model: 'baselineform', state: '/admin-forms'},
    {model: 'role', state: '/manage-user'},
    {model: 'role', state: '/user-level'},
    {model: 'cms', state: '/manage-portal'},
    {model: 'subscribe', state: '/subscribers'},
    {model: 'role', state: '/user-policies'},
    {model: 'user', state: '/add-user'},
    {model: 'user', state: '/approval-request'},
  ];
  withoutPermissionModule: string[] = ['home', 'dashboard', 'resources', 'impact-stories', 'about-us', 'ourpartners'];
  baselineFormLink: string[] = ['/forms-list', '/admin-forms', '/baseline-monthly-form', '/program-form', '/baseline-form'];
  managePortalPermission: string[] = ['cms', 'category', 'impactstories', 'glossary', 'inquiry', 'teammember', 'partners'];
  permissionJson: any =  JSON.parse(sessionStorage.getItem('userPermission') || '[]');
  constructor(private authService: AuthGuardService, private router: Router, private commonService: CommonServiceService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (!this.authService.isLoggedIn() && !sessionStorage.getItem('userPermission')) {
        this.router.navigate(['/home']); // go to login if not authenticated
        return false;
      }
      else if (sessionStorage.getItem('userPermission')){
        const path = state.url.split('?')[0].replace(/\/\d+$/, '');
        if (path === '/approval-request') {
          try {
            const userdata = JSON.parse(sessionStorage.getItem('userdata') || '{}');
            if (userdata?.userlevel_id !== 1) {
              this.router.navigate(['/home']);
              return false;
            }
          } catch (_) {
            this.router.navigate(['/home']);
            return false;
          }
        }
        return true;
      }
      return true;
  }
}
